import { render, staticRenderFns } from "./_privacy-policies.vue?vue&type=template&id=9723d7ca"
import script from "./_privacy-policies.vue?vue&type=script&lang=js"
export * from "./_privacy-policies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports